<template>
  <section class="signup-campaign-banner" role="region" :aria-label="t('campaign.signupBonus.title')">
    <button
      type="button"
      class="dismiss-btn"
      :aria-label="t('campaign.signupBonus.dismissAriaLabel')"
      @click="handleDismissBanner"
    >
      <Icon name="material-symbols:close" size="18" />
    </button>

    <button type="button" class="banner-link" @click="handleOpenAuth">
      <img
        class="banner-image"
        :src="bannerImageSrc"
        :alt="t('campaign.signupBonus.imageAlt')"
        loading="lazy"
      />
    </button>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '~/stores/user';
import { dismissSignupCampaignBanner } from '~/utils/campaignBannerDismissal';

const userStore = useUserStore();
const { t, locale } = useI18n();
const emit = defineEmits<{
  (e: 'dismiss'): void
}>();

const bannerImageSrc = computed(() => {
  return locale.value === 'en'
    ? '/images/campaign/new-user-signup-bonus-banner-en.svg'
    : '/images/campaign/new-user-signup-bonus-banner-zh.svg';
});

const handleOpenAuth = () => {
  userStore.setAuthModalVisible(true);
};

const handleDismissBanner = () => {
  dismissSignupCampaignBanner();
  emit('dismiss');
};
</script>

<style scoped lang="scss">
.signup-campaign-banner {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  margin: 0;
  padding: 8px 0 0;
  position: relative;
}

.banner-link {
  display: block;
  width: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  cursor: pointer;
}

.banner-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 0;
  box-shadow: 0 12px 28px rgba(15, 42, 84, 0.24);
}

.dismiss-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.88);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #ffffff;
  }
}

@media (max-width: 992px) {
  .signup-campaign-banner {
    padding: 6px 0 0;
  }

  .dismiss-btn {
    top: 12px;
    right: 12px;
  }
}

@media (max-width: 640px) {
  .banner-image {
    border-radius: 0;
  }

  .dismiss-btn {
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
  }
}
</style>
